import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightConnector = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 85,
	height: 12,
	viewBox: "0 0 85 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 5.52298L6.55671e-08 6.27298L83.6667 6.27297L83.6667 5.52297L83.6667 4.77297L-6.55671e-08 4.77298L0 5.52298ZM84.197 6.0533C84.4899 5.76041 84.4899 5.28554 84.197 4.99264L79.424 0.219672C79.1311 -0.0732214 78.6562 -0.0732214 78.3634 0.219672C78.0705 0.512565 78.0705 0.987439 78.3634 1.28033L82.606 5.52297L78.3634 9.76561C78.0705 10.0585 78.0705 10.5334 78.3634 10.8263C78.6563 11.1192 79.1311 11.1192 79.424 10.8263L84.197 6.0533Z" })
});
export default SvgArrowRightConnector;
